import App from './App.vue'
import VueScrollTo from 'vue-scrollto'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from './i18n'
import Scrollspy from 'vue2-scrollspy'

// Define SmartFit callback BEFORE Vue initialization
// This ensures the function exists when the custom element parses the onselect attribute
window.handleSmartFitSelect = function(event) {
  // This will be replaced by the actual handler in App.vue created() hook
};

Vue.config.productionTip = false;

//axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

Vue.use(VueAxios, axios, Scrollspy)

// scroll to
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -90,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})


// accordion
Vue.component('accordion', {

  template: `<div class="accordion">
    <div class="header" v-on:click="toggle">
      <slot name="header">HINT</slot>
      <i class="fas fa-caret-down header-icon" v-bind:class="{ 'fa-caret-up': onShow }"></i>
    </div>
    <transition :name="accordion">
      <div class="body" v-show="onShow">
        <div class="body-inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>`,

  data() {
    return {
      onShow: this.show,
      initShow: false
    };
  },
    props: {
      show: Boolean,
      accordion: {
        type: String,
        default: 'bottomToTop'
      },
    },
  methods: {
    toggle: function() {

      if(this.onShow === false && this.initShow === false) {
        if(this.$parent.$parent.page === 'personalize') this.$parent.getGroupData()
        this.initShow = true;
        this.onShow = !this.onShow;
      } else {
        this.onShow = !this.onShow;
        if(this.$parent.$parent.page === 'personalize' && this.$parent.group) {
          let scrollToContainer = '#'+this.$parent.group.replace(/ /gi, "_");
          VueScrollTo.scrollTo(scrollToContainer);
        } else if(this.$parent.$parent.page === 'accessories' && this.$parent.groupId) {
          let scrollToContainer = '#'+this.$parent.groupId;
          VueScrollTo.scrollTo(scrollToContainer);
        }
      }
    }
  }
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')